/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(3);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(4);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _jsFormValidate = __webpack_require__(5);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _messages = __webpack_require__(6);

	var _messages2 = _interopRequireDefault(_messages);

	var _relocations = __webpack_require__(7);

	var _relocations2 = _interopRequireDefault(_relocations);

	var _select = __webpack_require__(8);

	var _select2 = _interopRequireDefault(_select);

	var _select2Ajax = __webpack_require__(9);

	var _select2Ajax2 = _interopRequireDefault(_select2Ajax);

	var _searchBlock = __webpack_require__(10);

	var _searchBlock2 = _interopRequireDefault(_searchBlock);

	var _toggle = __webpack_require__(11);

	var _toggle2 = _interopRequireDefault(_toggle);

	var _regionalMap = __webpack_require__(12);

	var _regionalMap2 = _interopRequireDefault(_regionalMap);

	var _equalHeights = __webpack_require__(13);

	var _equalHeights2 = _interopRequireDefault(_equalHeights);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		//Messages
		_messages2.default.init();

		// Select 2
		_select2.default.init();

		// Select 2 on AjaxComplete
		_select2Ajax2.default.init();

		// Search
		_searchBlock2.default.init();

		// Relocations
		_relocations2.default.init();

		// Toggle
		_toggle2.default.init();

		// Regional map
		_regionalMap2.default.init();

		// Equal heights
		_equalHeights2.default.init();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domMenuBtn: $('.js-menu-btn'),
	  $domMenuNav: $('.js-main-nav'),
	  $domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
	  classOpen: 'open',
	  classOpenMenu: 'menu-open',
	  classSubMenu: '.menu-item--expanded > .menu',
	  classSubIcon: '.sub-icon',
	  classMenu: '.menu',
	  classList: 'li',

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // functions
	    var closeNav = function closeNav() {
	      Menu.$domMenuBtn.removeClass(Menu.classOpen);
	      Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
	      Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
	      _global2.default.$domBody.removeClass(Menu.classOpenMenu);
	    };

	    if (_global2.default.varsWindowWidth < 1280) {
	      Menu.$domMenuHasSub.on('click', function (e) {
	        e.preventDefault();
	        Menu.$domMenuHasSub.toggleClass('open');
	        $('.menu-item--expanded > .menu').toggleClass('open');
	      });
	    }

	    // bind events
	    Menu.$domMenuBtn.on('click', function (e) {
	      e.preventDefault();
	      Menu.$domMenuBtn.toggleClass(Menu.classOpen);
	      Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
	      Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
	      _global2.default.$domBody.toggleClass(Menu.classOpenMenu);
	    });

	    Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
	      var self = $(e.currentTarget);

	      if (self.hasClass(Menu.classOpen)) {
	        self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
	        self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
	        self.siblings().find(Menu.classMenu).slideUp();
	      } else {
	        self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
	        self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
	        self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
	      }
	    });

	    _global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

	    _global2.default.functions.escKey(closeNav);

	    var mainNav = $('#block-hca-headermenu');
	    var searchBlock = $('#block-hca-search');

	    function menuRelocation() {

	      var windowWidth = window.innerWidth;

	      if (windowWidth < 992) {

	        $('#block-hca-headermenu').remove();
	        $('#block-hca-search').remove();

	        mainNav.insertBefore('#block-hca-main-menu > ul > li:first-of-type');
	        searchBlock.insertBefore('#block-hca-headermenu');

	        // Explicitly show them AFTER moving
	        mainNav.css('display', 'block');
	        searchBlock.css('display', 'block');
	      }
	    }

	    menuRelocation();

	    $(window).on('resize', function () {
	      menuRelocation();
	    });
	  }
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$hpBannerSlider: $('#block-mainsliderblock .c-slider'),
		$hcaHistorySlider: $('.paragraph-id-19 .field-field_paragraphs'),
		$hcaNationalAwardsSlider: $('.paragraph--type--hca-national-awards .field-field_paragraphs'),
		$hpCorporatePartnersSlider: $('#block-hca-corporatepartners .field-field_paragraphs'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// HP Banner slider
			Sliders.$hpBannerSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000
			});

			$(document).ready(function () {
				$('#block-mainsliderblock .slick-dots').prepend($('#block-mainsliderblock .slick-prev'));
				$('#block-mainsliderblock .slick-dots').append($('#block-mainsliderblock .slick-next'));
				$('#block-mainsliderblock .slick-prev').text('Prev');
			});

			Sliders.$hpCorporatePartnersSlider.slick({
				infinite: true, // important
				slidesToShow: 5,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: false,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: false, // important
				autoplaySpeed: 4000,
				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});

			Sliders.$hcaNationalAwardsSlider.slick({
				infinite: false, // important
				slidesToShow: 3,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: false,
				dots: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: false, // important
				autoplaySpeed: 4000,
				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});

			// About slider
			Sliders.$hcaHistorySlider.slick({
				infinite: false, // important
				slidesToShow: 4,
				slidesToScroll: 4,
				speed: 1000,
				arrows: true,
				autoplay: false,
				dots: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: false, // important
				autoplaySpeed: 4000,
				centerMode: false,
				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sticky = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    $header: $('.js-header'),
	    $content: $('.js-site-content'),
	    classSticky: 'sticky-header',
	    classStickyContent: 'sticky-content',

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        $(window).on('scroll', function () {
	            if ($(window).scrollTop() >= 30) {
	                Sticky.$content.addClass(Sticky.classStickyContent);
	                Sticky.$header.addClass(Sticky.classSticky);
	            } else {
	                Sticky.$content.removeClass(Sticky.classStickyContent);
	                Sticky.$header.removeClass(Sticky.classSticky);
	            }
	        });
	    }
	};

	exports.default = Sticky;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var FormValidate = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    // Use this class for every form you whant to validate
	    classForm: '.js-validation',

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        if ($(FormValidate.classForm).length > 0) {
	            $.validate({
	                form: FormValidate.classForm
	            });
	        }
	    }
	};

	exports.default = FormValidate;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {

	  init: function init() {

	    $(document).ready(function () {
	      $('div[role="contentinfo"]').append('<div class="close-button"></div>');

	      function closeFlashMessages() {
	        $('body').find('div[role="contentinfo"] .close-button').on('click', function (e) {
	          $('div[role="contentinfo"]').addClass('hide');
	        });
	      }

	      closeFlashMessages();

	      $(document).ajaxComplete(function () {
	        closeFlashMessages();
	      });
	    });
	  }
	};

	exports.default = Messages;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Relocations = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // Cloning title
	    jQuery(document).ready(function () {
	      var blocks = ['hca-membership', 'hca-hcaforum', 'hca-heretohelp', 'hca-hospitalcaterers'];

	      blocks.forEach(function (id) {
	        var title = $('#block-' + id + ' .field-field_title').clone();
	        $('#block-' + id).append(title);
	      });
	    });

	    // News block on HP
	    jQuery(document).ready(function () {
	      var $newsHeading = $('#block-hca-views-block-news-homepage-news-block > h2');
	      var $moreLink = $('#block-hca-views-block-news-homepage-news-block .more-link');

	      if ($newsHeading.length && $moreLink.length) {
	        var $wrapper = $('<div class="heading-more-link-wrapper"></div>');
	        $newsHeading.add($moreLink).wrapAll($wrapper);
	      }
	    });

	    // Service Excellence HCA National Awards paragraph wrapper
	    jQuery(document).ready(function () {
	      jQuery('.paragraph--type--hca-national-awards-media').each(function () {
	        var $paragraph = jQuery(this);
	        var $paragraphTitle = $paragraph.find('.field-field_title');
	        var $paragraphBody = $paragraph.find('.field-field_body');

	        if ($paragraphTitle.length && $paragraphBody.length) {
	          var $wrapper = jQuery('<div class="title-body-wrapper"></div>');
	          $paragraphTitle.add($paragraphBody).wrapAll($wrapper);
	        }
	      });
	    });

	    // Nutrition & Hydration HP block
	    jQuery(document).ready(function () {
	      var $heading = $('#block-hca-nutritionhydration247365 > h2');
	      var $bodyLinkWrapper = $('#block-hca-nutritionhydration247365 .homepage-ad-body-link-wrapper');

	      if ($heading.length && $bodyLinkWrapper.length) {
	        $heading.add($bodyLinkWrapper).wrapAll('<div class="heading-text-wrapper"></div>');
	      }
	    });

	    // Member's area webinars block
	    $(document).ready(function () {
	      $("#block-hca-webinarshomepageblock-2").each(function () {
	        $(this).children("div").wrapAll('<div class="members-area-webinars-wrapper"></div>');
	      });
	    });

	    // About us prefooter paragraph wrapper
	    $(document).ready(function () {
	      $(".paragraph--type--prefooter").each(function () {
	        $(this).children("div").wrapAll('<div class="title-body-cta-wrapper"></div>');
	      });
	    });

	    // Service Excellence HCA National Awards paragraph wrapper
	    $(document).ready(function () {
	      $(".paragraph--type--hca-national-awards").each(function () {
	        $(this).children("div").wrapAll('<div class="paragraph-fields-wrapper"></div>');
	      });
	    });

	    // Events listing h3 relocation
	    function moveHeading() {
	      $('.view-events .view-content > h3').each(function () {
	        $(this).insertAfter('.view-events > .views-title-filter-wrapper, .view-events > .view-filters');
	      });
	    }

	    // Run on page load
	    $(document).ready(function () {
	      moveHeading();
	    });

	    // Run after AJAX completes
	    $(document).ajaxComplete(function () {
	      moveHeading();
	    });

	    // About us slider arrows wrapper
	    jQuery(document).ready(function () {
	      var $prevButton = $('.paragraph--type--hca-history-wrapper .slick-prev, .paragraph--type--hca-national-awards .slick-prev');
	      var $nextButton = $('.paragraph--type--hca-history-wrapper .slick-next, .paragraph--type--hca-national-awards .slick-next');

	      if ($prevButton.length && $nextButton.length) {
	        var $arrowsWrapper = $('<div class="slider-arrows-wrapper"></div>');
	        $prevButton.add($nextButton).wrapAll($arrowsWrapper);
	      }
	    });
	  }
	};

	exports.default = Relocations;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Select an option");

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _select = __webpack_require__(8);

	var _select2 = _interopRequireDefault(_select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2Ajax = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			$(document).ajaxComplete(function () {
				_select2.default.init();
				$('select[id*="edit-field-categories-target-id"]').select2();
				$('select[id*="edit-payment-information-billing-information-select-address"]').select2();
			});
		}
	};

	exports.default = Select2Ajax;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var SearchBlock = {
	  $searchForm: $('.c-header').find('#search-block-form'),
	  $searchInputWrap: $('.c-header').find('#search-block-form').find('.form-item-keys'),
	  $searchInput: $('.c-header').find('#search-block-form').find('[id*="edit-keys"]'),
	  $searchBtn: $('.c-header').find('#search-block-form').find('[id*="edit-submit"]'),

	  init: function init() {

	    var windowWidth = window.innerWidth;

	    if (windowWidth > 992) {
	      SearchBlock.$searchBtn.on('click', function (event, el) {
	        event.preventDefault();
	        event.stopPropagation();

	        if (!SearchBlock.$searchInputWrap.hasClass('expanded')) {
	          SearchBlock.$searchInputWrap.addClass('expanded');
	          SearchBlock.$searchInput.focus();
	        } else {
	          if (SearchBlock.$searchInput.val() == '') {
	            SearchBlock.$searchInputWrap.removeClass('expanded');
	          } else {
	            SearchBlock.$searchForm.trigger('submit');
	          }
	        }
	      });

	      $(document).click(function (e) {
	        var inputElementCheck = e.target.id != $('[id*="edit-keys"]').attr('id');
	        if (SearchBlock.$searchInput.val() === '' && inputElementCheck) {
	          SearchBlock.$searchInputWrap.removeClass('expanded');
	        }
	      });
	    } else {
	      // Mobile/tablet behavior (≤ 992px): input is always visible
	      SearchBlock.$searchInput.on('focus', function (event) {
	        requestAnimationFrame(function () {
	          SearchBlock.$searchInput.focus();
	        });
	      });
	    }
	  }
	};

	exports.default = SearchBlock;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Toggle = {

	   init: function init() {
	      // const toggleArrow = document.getElementsByClassName("toggle-arrow")[0];

	      // toggleArrow.addEventListener("click", function () {
	      //   this.parentNode.classList.toggle("open");
	      // });

	      var toggleArrows = document.getElementsByClassName("toggle-arrow");

	      for (var i = 0; i < toggleArrows.length; i++) {
	         toggleArrows[i].addEventListener("click", function (event) {
	            event.preventDefault();
	            event.stopPropagation();
	            this.parentNode.classList.toggle("open");
	         });
	      }
	   }
	};

	exports.default = Toggle;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var RegionalMap = {
	  /*-------------------------------------------------------------------------------
	  	# Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    $(document).ajaxComplete(function () {
	      function handleHover(element, addClass) {
	        var tidValue = $(element).data("tid-value");

	        if (tidValue) {
	          var correspondingPath = $("svg#branches path[data-tid-value=\"" + tidValue + "\"]");
	          var correspondingLink = $(".branches-list-item a[data-tid-value=\"" + tidValue + "\"]");

	          if (addClass) {
	            correspondingPath.addClass("colored");
	            correspondingLink.addClass("colored");
	          } else {
	            correspondingPath.removeClass("colored");
	            correspondingLink.removeClass("colored");
	          }
	        }
	      }

	      $(".branches-list-item a").hover(function () {
	        handleHover(this, true);
	      }, function () {
	        handleHover(this, false);
	      });

	      $("svg#branches path").hover(function () {
	        handleHover(this, true);
	      }, function () {
	        handleHover(this, false);
	      });

	      $(".branches-list-item a.active").each(function () {
	        var tidValue = $(this).data("tid-value");

	        if (tidValue) {
	          $("svg#branches path[data-tid-value=\"" + tidValue + "\"]").addClass("active");
	        }
	      });
	    });

	    $(document).ready(function () {
	      function setActiveState(tidValue) {
	        if (tidValue) {
	          $(".branches-list-item a, svg#branches path").removeClass("clicked");
	          $(".branches-list-item a[data-tid-value=\"" + tidValue + "\"]").addClass("clicked");
	          $("svg#branches path[data-tid-value=\"" + tidValue + "\"]").addClass("clicked");
	        }
	      }

	      $(document).on("click", ".branches-list-item a", function (e) {
	        // e.preventDefault();
	        var tidValue = $(this).data("tid-value");
	        setActiveState(tidValue);
	      });

	      // $(document).on("click", "svg#branches path", function () {
	      //   const tidValue = $(this).data("tid-value");

	      //   if (tidValue) {
	      //     const correspondingLink = $(`.branches-list-item a[data-tid-value="${tidValue}"]`);
	      //     correspondingLink.trigger("click");
	      //   }
	      // });

	      $(document).on("click", "svg#branches path", function () {
	        var tidValue = $(this).data("tid-value");

	        if (tidValue) {
	          var correspondingLink = $(".branches-list-item a[data-tid-value=\"" + tidValue + "\"]");

	          if (correspondingLink.length) {
	            window.location.href = correspondingLink.attr("href");
	          }
	        }
	      });

	      var observer = new MutationObserver(function () {
	        $(".branches-list-item a").each(function () {
	          var tidValue = $(this).data("tid-value");
	          if ($(this).hasClass("clicked")) {
	            $("svg#branches path[data-tid-value=\"" + tidValue + "\"]").addClass("clicked");
	          }
	        });
	      });

	      observer.observe(document.body, { childList: true, subtree: true });
	    });
	  }
	};

	exports.default = RegionalMap;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	'use strict'; // jshint ignore:line

	var EqualHeights = {
	  /*-------------------------------------------------------------------------------
	  	# Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  /*-------------------------------------------------------------------------------
	  	# Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    var equalHeights = function equalHeights(elm) {
	      setTimeout(function () {
	        var x = 0;

	        elm.height('auto');

	        elm.each(function (index, el) {
	          if ($(el).height() > x) {
	            x = $(el).height();
	          }
	        });

	        elm.height(x + 1);
	      }, 100);
	    };

	    // News view
	    // equalHeights($('.view-news .views-row:not(.highlight) h2'));

	    // Officers view
	    $(document).ajaxComplete(function () {
	      equalHeights($('.view-officers .views-row article h2'));
	      equalHeights($('.view-officers .views-row article .field-field_position'));
	      equalHeights($('.view-officers .views-row article .field-field_phone'));
	      equalHeights($('.view-officers .views-row article .field-field_email'));
	    });

	    // Members area
	    equalHeights($('.paragraph-id-49 .field-field_title, .paragraph-id-50 .field-field_title'));
	    equalHeights($('.paragraph-id-49 .field-field_body, .paragraph-id-50 .field-field_body'));

	    // Service excellence
	    equalHeights($('.paragraph-id-86 .field-field_body, .paragraph-id-87 .field-field_body'));

	    // Membership page
	    equalHeights($('.page-node-63 .field-field_paragraphs .first-row-wrapper .field-field_body'));
	    equalHeights($('.page-node-63 .field-field_paragraphs .second-row-wrapper .field-field_body'));

	    // Membership page
	    $('.page-node-63 .membership-group').each(function (index, group) {
	      equalHeights($(group).find('.field--item .field-field_body'));
	    });

	    // Webinars listing page
	    equalHeights($('.page-webinars .webinar-card-textbox'));
	  }
	};

	exports.default = EqualHeights;

/***/ })
/******/ ]);